import React from 'react';
import { Modal, Box, Typography, Stack, useMediaQuery, useTheme, Card } from '@mui/material';
import CustomButton from '../CustomButton';


const CustomCard = ({ children,
    ...typoProps
}) => {
    const theme = useTheme();


    return (
        <Card elevation={0} sx={{ height: "100%", borderRadius: '10px', bgcolor:'#f7f7f7a4', border:'1px solid gainsboro', boxShadow:'none'}} {...typoProps}>
            {children && (
                <Box >
                    {children}
                </Box>
            )}
        </Card>
    );
};

export default CustomCard;
